module.exports = require('./methods/xe-utils')



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/ctor.js
// module id = 1853
// module chunks = 106